import { type RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Search = lazy(() => import('../pages/search/page'));
const ProductsSearch = lazy(() => import('../pages/products/page'));
const SuppliersSearch = lazy(() => import('../pages/search/page'));
const PurchaseRequest = lazy(() => import('../pages/purchase-request/page'));
const SupplierDetail = lazy(() => import('../pages/supplier/page'));
const Categories = lazy(() => import('../pages/categories/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const Help = lazy(() => import('../pages/help/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Login = lazy(() => import('../pages/auth/login'));
const Register = lazy(() => import('../pages/auth/register'));
const CheckRole = lazy(() => import('../pages/auth/check-role'));
const ChooseRole = lazy(() => import('../pages/auth/choose-role'));
const SupplierSetup = lazy(() => import('../pages/auth/supplier-setup'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const DashboardPurchaseRequestsList = lazy(
  () => import('../pages/dashboard/purchase-requests/list/page')
);
const DashboardPurchaseRequestDetail = lazy(
  () => import('../pages/dashboard/purchase-requests/detail/page')
);
const PaymentSuccess = lazy(() => import('../pages/payment/success/page'));
const PaymentFailed = lazy(() => import('../pages/payment/failed/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Admin = lazy(() => import('../pages/admin/page'));
const Notifications = lazy(() => import('../pages/notifications/page'));
const NewsletterUnsubscribe = lazy(
  () => import('../pages/newsletter/unsubscribe/page')
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/search',
    element: <SuppliersSearch />,
  },
  {
    path: '/products',
    element: <ProductsSearch />,
  },
  {
    path: '/purchase-request',
    element: <PurchaseRequest />,
  },
  {
    path: '/supplier/:id',
    element: <SupplierDetail />,
  },
  {
    path: '/categories',
    element: <Categories />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/help',
    element: <Help />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/auth/login',
    element: <Login />,
  },
  {
    path: '/auth/register',
    element: <Register />,
  },
  {
    path: '/auth/check-role',
    element: <CheckRole />,
  },
  {
    path: '/auth/choose-role',
    element: <ChooseRole />,
  },
  {
    path: '/auth/supplier-setup',
    element: <SupplierSetup />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/dashboard/purchase-requests',
    element: <DashboardPurchaseRequestsList />,
  },
  {
    path: '/dashboard/purchase-requests/:requestId',
    element: <DashboardPurchaseRequestDetail />,
  },
  {
    path: '/notifications',
    element: <Notifications />,
  },
  {
    path: '/newsletter/unsubscribe',
    element: <NewsletterUnsubscribe />,
  },
  {
    path: '/payment/success',
    element: <PaymentSuccess />,
  },
  {
    path: '/payment/failed',
    element: <PaymentFailed />,
  },
  {
    path: '/admin/*',
    element: <Admin />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;